import { NgModule  }             from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                           from '../shared/shared.module';
import { TableModule }                            from '../table/table.module';
import { VehicleActionsComponent }                from './vehicle.actions.component';
import { VehicleAdvertisingComponent }            from './vehicle.advertising.component';
import { VehicleEventsComponent }                 from './vehicle.events.component';
import { VehicleHistoryActionsComponent }         from './vehicle.history.actions.component';
import { VehicleHistoryRowExpandComponent }       from './vehicle.history.row.expand.component';
import { VehicleImportedHistoryActionsComponent } from './vehicle.imported-history.actions.component';
import { VehicleImportedHistoryComponent }        from './vehicle.imported-history.component';
import { VehicleImportedHistoryNotesComponent }   from './vehicle.imported-history.notes.component';
import { VehicleInfoComponent }                   from './vehicle.info.component';
import { VehicleInspectionsComponent }            from './vehicle.inspections.component';
import { VehicleInvoiceItemsRowExpandComponent }  from './vehicle.invoice-items.row.expand.component';
import { VehicleInvoicesComponent }               from './vehicle.invoices.component';
import { VehiclesComponent }                      from './vehicles.component';
import { VehiclesService }                        from './vehicles.service';
import { VehiclesStates }                         from './vehicles.states';
import { VehicleTransactionComponent }            from './vehicle.transaction.component';
import { VehicleTransactionsComponent }           from './vehicle.transactions.component';

@NgModule({
  declarations: [
    VehicleActionsComponent,
    VehicleAdvertisingComponent,
    VehicleEventsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleImportedHistoryActionsComponent,
    VehicleImportedHistoryComponent,
    VehicleImportedHistoryNotesComponent,
    VehicleInfoComponent,
    VehicleInspectionsComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehicleInvoicesComponent,
    VehiclesComponent,
    VehicleTransactionComponent,
    VehicleTransactionsComponent
  ],
  entryComponents: [
    VehicleActionsComponent,
    VehicleAdvertisingComponent,
    VehicleEventsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleImportedHistoryActionsComponent,
    VehicleImportedHistoryComponent,
    VehicleImportedHistoryNotesComponent,
    VehicleInfoComponent,
    VehicleInspectionsComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehicleInvoicesComponent,
    VehiclesComponent,
    VehicleTransactionComponent,
    VehicleTransactionsComponent
  ],
  exports: [
    VehicleActionsComponent,
    VehicleAdvertisingComponent,
    VehicleEventsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleImportedHistoryActionsComponent,
    VehicleImportedHistoryComponent,
    VehicleImportedHistoryNotesComponent,
    VehicleInfoComponent,
    VehicleInspectionsComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehicleInvoicesComponent,
    VehiclesComponent,
    VehicleTransactionComponent,
    VehicleTransactionsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: VehiclesStates })
  ],
  providers: [
    VehiclesService
  ]
})
export class VehiclesModule {}
